import { render, staticRenderFns } from "./IncidentModal.vue?vue&type=template&id=468e3dba&"
import script from "./IncidentModal.vue?vue&type=script&lang=js&"
export * from "./IncidentModal.vue?vue&type=script&lang=js&"
import style0 from "./IncidentModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports